<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin:auto;background:#fff;display:block;" :width="width" :height="height" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
        <g transform="rotate(0 50 50)">
            <rect x="47.5" y="5" rx="2.5" ry="2.6" width="5" height="20" fill="#17a2b8">
                <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9345794392523364s" begin="-0.8853910477127397s" repeatCount="indefinite"></animate>
            </rect>
        </g><g transform="rotate(18.94736842105263 50 50)">
            <rect x="47.5" y="5" rx="2.5" ry="2.6" width="5" height="20" fill="#17a2b8">
                <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9345794392523364s" begin="-0.836202656173143s" repeatCount="indefinite"></animate>
            </rect>
        </g><g transform="rotate(37.89473684210526 50 50)">
            <rect x="47.5" y="5" rx="2.5" ry="2.6" width="5" height="20" fill="#17a2b8">
                <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9345794392523364s" begin="-0.7870142646335464s" repeatCount="indefinite"></animate>
            </rect>
        </g><g transform="rotate(56.8421052631579 50 50)">
            <rect x="47.5" y="5" rx="2.5" ry="2.6" width="5" height="20" fill="#17a2b8">
                <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9345794392523364s" begin="-0.7378258730939498s" repeatCount="indefinite"></animate>
            </rect>
        </g><g transform="rotate(75.78947368421052 50 50)">
            <rect x="47.5" y="5" rx="2.5" ry="2.6" width="5" height="20" fill="#17a2b8">
                <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9345794392523364s" begin="-0.6886374815543531s" repeatCount="indefinite"></animate>
            </rect>
        </g><g transform="rotate(94.73684210526316 50 50)">
            <rect x="47.5" y="5" rx="2.5" ry="2.6" width="5" height="20" fill="#17a2b8">
                <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9345794392523364s" begin="-0.6394490900147565s" repeatCount="indefinite"></animate>
            </rect>
        </g><g transform="rotate(113.6842105263158 50 50)">
            <rect x="47.5" y="5" rx="2.5" ry="2.6" width="5" height="20" fill="#17a2b8">
                <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9345794392523364s" begin="-0.5902606984751598s" repeatCount="indefinite"></animate>
            </rect>
        </g><g transform="rotate(132.6315789473684 50 50)">
            <rect x="47.5" y="5" rx="2.5" ry="2.6" width="5" height="20" fill="#17a2b8">
                <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9345794392523364s" begin="-0.5410723069355632s" repeatCount="indefinite"></animate>
            </rect>
        </g><g transform="rotate(151.57894736842104 50 50)">
            <rect x="47.5" y="5" rx="2.5" ry="2.6" width="5" height="20" fill="#17a2b8">
                <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9345794392523364s" begin="-0.4918839153959665s" repeatCount="indefinite"></animate>
            </rect>
        </g><g transform="rotate(170.52631578947367 50 50)">
            <rect x="47.5" y="5" rx="2.5" ry="2.6" width="5" height="20" fill="#17a2b8">
                <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9345794392523364s" begin="-0.44269552385636984s" repeatCount="indefinite"></animate>
            </rect>
        </g><g transform="rotate(189.47368421052633 50 50)">
            <rect x="47.5" y="5" rx="2.5" ry="2.6" width="5" height="20" fill="#17a2b8">
                <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9345794392523364s" begin="-0.3935071323167732s" repeatCount="indefinite"></animate>
            </rect>
        </g><g transform="rotate(208.42105263157896 50 50)">
            <rect x="47.5" y="5" rx="2.5" ry="2.6" width="5" height="20" fill="#17a2b8">
                <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9345794392523364s" begin="-0.34431874077717656s" repeatCount="indefinite"></animate>
            </rect>
        </g><g transform="rotate(227.3684210526316 50 50)">
            <rect x="47.5" y="5" rx="2.5" ry="2.6" width="5" height="20" fill="#17a2b8">
                <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9345794392523364s" begin="-0.2951303492375799s" repeatCount="indefinite"></animate>
            </rect>
        </g><g transform="rotate(246.31578947368422 50 50)">
            <rect x="47.5" y="5" rx="2.5" ry="2.6" width="5" height="20" fill="#17a2b8">
                <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9345794392523364s" begin="-0.24594195769798324s" repeatCount="indefinite"></animate>
            </rect>
        </g><g transform="rotate(265.2631578947368 50 50)">
            <rect x="47.5" y="5" rx="2.5" ry="2.6" width="5" height="20" fill="#17a2b8">
                <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9345794392523364s" begin="-0.1967535661583866s" repeatCount="indefinite"></animate>
            </rect>
        </g><g transform="rotate(284.2105263157895 50 50)">
            <rect x="47.5" y="5" rx="2.5" ry="2.6" width="5" height="20" fill="#17a2b8">
                <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9345794392523364s" begin="-0.14756517461878996s" repeatCount="indefinite"></animate>
            </rect>
        </g><g transform="rotate(303.1578947368421 50 50)">
            <rect x="47.5" y="5" rx="2.5" ry="2.6" width="5" height="20" fill="#17a2b8">
                <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9345794392523364s" begin="-0.0983767830791933s" repeatCount="indefinite"></animate>
            </rect>
        </g><g transform="rotate(322.10526315789474 50 50)">
            <rect x="47.5" y="5" rx="2.5" ry="2.6" width="5" height="20" fill="#17a2b8">
                <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9345794392523364s" begin="-0.04918839153959665s" repeatCount="indefinite"></animate>
            </rect>
        </g><g transform="rotate(341.05263157894734 50 50)">
            <rect x="47.5" y="5" rx="2.5" ry="2.6" width="5" height="20" fill="#17a2b8">
                <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9345794392523364s" begin="0s" repeatCount="indefinite"></animate>
            </rect>
        </g>
    </svg>
</template>

<script>
export default {
    props: {
        height: {
            type: String,
            default: '50px'
        },
        width: {
            type: String,
            default: '50px'
        }
    },
    name: 'AppLoaderSvg'
};
</script>
